<template>
  <Candidates />
</template>

<script setup>
import Candidates from '@/sections/client/candidates/Candidates.vue';
</script>
